import { useCallback, useState } from "react"
import authInstance from './../utilities/axios/authInstance';
import {handleError} from '../utilities/errorHandler';
import { createMessage } from "../utilities/utilities";

export const useReports = () => {
    const [loading, setLoading] = useState(false);
    const [reports, setReports] = useState([]);
    const [report, setReport] = useState(null);
    const [message, setMessage] = useState({ show: false, text: '', variant: '' });
    const [isSaving, setIsSaving] = useState(false);

    // 1. Get all reports 
    const fetchReports = useCallback(async () => {
        setLoading(true);
        try {
            const response = await authInstance.get('reports');
            setReports(response.data);
        } catch (error) {
            setMessage(handleError(error, 'danger'));
        } finally {
            setLoading(false);
        }
    }, []);

    // 2. Get one 
    const getReport = async (id) => {
        setLoading(true);
        try {
            const response = await authInstance.get(`reports/${id}`);
            setReport(response.data);
            return response.data;
        } catch (error) {
            setMessage(handleError(error, 'danger'));
        } finally {
            setLoading(false);
        }
    };

    // 3. Create 
    const storeReport = async (data) => {
        setIsSaving(true);
        try {
            const response = await authInstance.post('reports', data);
            await fetchReports();
            setMessage(createMessage('Report successfully saved.', 'success'));
            return response.data;
        } catch (error) {
            if (error.response?.status !== 422){
                setMessage(handleError(error));
            }

            throw error;
        } finally {
            setIsSaving(false);
        }
    };

    // 4. Update 
    const updateReport = async (id, data) => {
        setIsSaving(true);
        try {
            const response = await authInstance.put(`reports/${id}`, data);
            await fetchReports();
            setMessage(createMessage('Report successfully updated', 'success'));
            return response.data
        } catch (error) {
            if (error.response?.status !== 422) {
                setMessage(handleError(error));
            }

            throw error;
        } finally {
            setIsSaving(false);
        }
    };

    // 5. Delete 
    const deleteReport = async (id) => {
        setLoading(true);
        try {
            await authInstance.delete(`reports/${id}`);
            setReports(prev => prev.filter(r => r.id !== id));
        } catch (error) {
            setMessage(handleError(error));
        } finally {
            setLoading(false);
        }
    };

    // 6. Search for reports 
    const searchReport = async (inputValue) => {
        setLoading(true);
        try {
            const response = await authInstance.get('search/reports/', {
                params: {
                    name: inputValue
                }
            });

            setReports(response.data);
            return response.data;
        } catch (error) {
            setMessage(handleError(error));
        } finally {
            setLoading(false);
        }
    }

    return {
        reports,
        report,
        loading,
        isSaving,
        message,
        setMessage,
        fetchReports,
        getReport,
        storeReport,
        updateReport,
        deleteReport,
        searchReport,
    };
}